/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {OpaqueToken} from '@angular/core';

export const ON_WEB_WORKER = new OpaqueToken('WebWorker.onWebWorker');

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
